import React, { useState, useContext, useEffect, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CREATE_ORDER_MONOG, GET_GOODS_LIST } from '../../../../../modules/API/settings'
import { LOAD, LOAD_END, LOGOUT } from '../../../../../../store/actions/actionsTypes'
import { ContextModal } from '../../../../../modules/modal/modalContext'
import GoodsList from './goods/goodsList'
import ProductGroupSelector from '../Components/ProductGroupSelector'
import { format } from "date-fns"
import './modalAzmanot.scss'
import styled from 'styled-components'
import { useBeforeunload } from 'react-beforeunload'
import PresetModal from './presets/presetModal'
import FloatContainer from './sideFloatMenu/floatContainer'
import { vibrationFunc } from '../../../../../modules/vibrationModule'
import Disclaimer from '../../teudotProblems/Components/Disclaimer'
import CloseIcon from '../../../../../generic/icons/IconLib/XIcon'
import SpeedIcon from '../../../../../generic/icons/IconLib/TruckIcon'
import ChecklistIcon from '../../../../../generic/icons/IconLib/ChecklistIcon'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import BasketIcon from '../../../../../generic/icons/IconLib/BasketIcon'
import { statusConverter } from '../../../../../generic/artcoded/statusAzmanot'
import selectBrodMigdal from '../../../../../generic/utils/selectBrodMigdal'
import { addIDForTheList } from '../../../../../generic/utils/addUIDForTheList'
import { useNavigate } from 'react-router-dom'
import { Orders } from '../../../../../modules/API/Orders/orders'
import { LINKS } from '../../../../../Routs/config'
import useDataFetcher from '../../knisot/hooks/useFetchData'
import CustomersOrdered from './CustomersOrdered'
import { checkPackType } from '../../../../../generic/utils/checkPackType'
import axios from 'axios'
import Basket from '../../../../../generic/basket/Basket'
import useBasket from './hooks/useBasket'
import { handleNotifications } from '../../../../../generic/utils/handleNotifications'
import ColumModal from '../../../../../generic/Layouts/ColumModal'
import RemarkOrderModal from '../Components/RemarkOrderModal'
import useRemarkModal from '../../../../../generic/hooks/useRemarkModal'
import { Price } from '../../../../../modules/API/Prices/price'
import OrdersPageLayout from '../Components/OrdersPageLayout'
import ClientSelector from '../../../../../generic/ui/ClientSelector/ClientSelector'
import DateField from '../Components/DateField'
import OrderActionDock from '../Components/OrderActionDock'
import OrderHeaderBlock from '../Components/OrderHeaderBlock'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import OrdersToolbar from '../Components/OrdersToolbar'

// Legacy wrappers — kept exported for other modules that still consume them
// (priceReport, editTeudat, etc.). Inside this modal the layout is now
// provided by OrdersPageLayout.
export const MainSection = styled.div`
    position: relative;
    background: #e9f0f0;
    padding: 0.5em;
    width: 100%;
    height: 100%;
    @media screen and (max-width: 450px) {
        padding: 0;
    }
`
export const InnerWrapper = styled.div`
    position: relative;
    max-width: 1000px;
    height: 100%;
    background: #e9f3f2;
    margin: 0 auto;
    padding: 0 0.5em;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    gap: 0.1em;
    overflow: hidden;
    border-radius: 30px;
    @media screen and (max-width: 450px) {
        padding: 1em 0.5em 0 0.5em;
    }
`
// Local copy of the legacy "pill" panel (was imported from SelectBar).
// Kept inline so this modal owns its own styling and doesn't depend on
// the orders SelectBar — that one has been redesigned independently.
const SelectPanelWrapper = styled.div`
    position: relative;
    width: 100%;
    min-height: 4.5em;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5em;
    background: #fdfdfd;
    padding: 0 0.5em;
    border-radius: 40px;
    -webkit-box-shadow: -2px 8px 2px -6px rgba(41, 127, 118, 0.71);
    box-shadow: -2px 8px 2px -6px rgba(41, 127, 118, 0.71);
`
export const AkpacaContainer = styled.div`
    position: absolute;
    right: -1em;
    bottom: -0.5em;
    min-width: 2em;
    min-height: 2em;
    border-radius: 50%;
    background: #fdfdfd;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    -webkit-box-shadow: 0px 1px 2px 2px rgba(161,161,161,0.1); 
    box-shadow: 0px 1px 2px 2px rgba(161,161,161,0.1);
`
export const SearchWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-end;
`

export const DateWrapper = styled.div`
    max-width: 110px;
    span {
        display: none;
    }
  .datePicker {
    height: 3.2em;
    border: none; 
    padding: 0.5em 1em; 
    text-align: right;
    border-radius: 30px;
    background: #eff3f4;
    font-size: 1.1em;
    max-width: 110px;
    color: #838484;
    outline: none;
  }
`
export const ControlPanelWrapper = styled.div`
    /* position: absolute;
    bottom: 0; */
    /* padding: 0 0.2em; */
    /* background: #80b3ae; */
    border-radius: 30px;
    width: 100%;
    min-height: 3em;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1em;
`




export default function ModalAzmanot({ 
    fileterGoods, 
    setFilterGoods,
    fileterGoodsDefault, 
    setFilterGoodsDefault, 
    getAzmanot, 
    filterGoodName, 
    setFilterGoodName
}) 
{

    const clientListDefault = useSelector(token => token.defaults.clientList.list)
    const dayJump = useSelector(item => item.defaults.defaults.filter(elem => elem.Int_ID === 338)[0])
   
    const [filterGoodsValue, setFilterGoodsValue] = useState(null)
    const [selectStatus, setSelectStatus] = useState(false)
    const [filterToggleStatus, setFilterToggleStatus] = useState(false)
    const [filteredProduct, setFilteredProduct] = useState([])
    const [selectedCustomer, setSelectedCustomer] = useState();
    //338
    const packegeList = useSelector(packages => packages?.defaults?.packageList);
    console.log(selectedCustomer)
    const controller = useRef(new AbortController());
    const defaults = useSelector(e => e.defaults?.defaults);
    const getToken = useSelector(token => token.mainReducer.token);
    const getUser = useSelector(token => token.mainReducer.user);
    const getRights = useSelector(rights => rights.mainReducer.user.rights);
    const isEditPrice = getRights.some(e => e === 'OFFICE' || e === 'SELLER' || e === 'ADMIN');
    const getTimeBrod = selectBrodMigdal(defaults, 342, 'Time_Value');
    const isEditArizot = selectBrodMigdal(defaults, 584, 'Logical_Value')
    const dateBlockerBMList = defaults.filter(item => item.Int_ID === 551);
    const dateBlocker = (dateBlockerBMList.length > 1 ? dateBlockerBMList.find(item => item.UserName.trim() === getUser.name.trim())?.Logical_Value 
                                : dateBlockerBMList[0]?.Logical_Value) ;
    const getMlai = selectBrodMigdal(defaults, 546, 'Logical_Value');
    const rawData = defaults.filter(item => item.Int_ID === 547);
    const getMhir = (
        rawData.length > 1 ? rawData.find(item => item.UserName.trim() === getUser.name.trim())?.Logical_Value 
        : rawData[0]?.Logical_Value
    )
    const getPresetBrod = selectBrodMigdal(defaults, 555, 'Logical_Value');
    const brodDate = new Date().setDate(new Date().getDate() + (dayJump?.Num_Value || 0))
    const [isLoadPrice, setIsLoadPrice] = useState(false)
    const [presetWindow, setPresetWindow] = useState(false);
    const [orderTotal, setOrderTotal] = useState(0);
    const [blockSave, setBlockSave] = useState(false);
    const [modal, setModal] = useContext(ContextModal);
    const [customerId, setCustomerId] = useState('');
    const [jumping, setJumping] = useState(false);
    
    // Use the custom remark modal hook
    const {
        isOpen: isRemarkModalOpen,
        remark: generalRemark,
        handleToggle: handleOpenRemarkModal,
        handleSave: handleSaveRemark,
        handleClose: handleCloseRemarkModal,
        modalProps: modalRemarkProps
    } = useRemarkModal({ defaultRemark: '' });
    const [product, setProduct] = useState([]);
    const [productDefault, setProductDefault] = useState([]);
    const [statusFilter, setStatisFilter] = useState(true);
    const [filteredExist, setFilteredExist] = useState([]);
    const [addictinalDay, setAddictionalDay] = useState('0');
    const [input, setInput] = useState('')
    const [imputGoods, setInputGoods] = useState('');
    const [goodsList, setGoodsList] = useState([]);
    const [goodsListDefault, setGoodsListDefault] = useState([]);
    const goodsListTemp = goodsListDefault;
    const [showSearchGoods, setShowSearchGoods] = useState(false);
    const [showGoodsList, setShowGoodsList] = useState(true);
    const [startDate, setStartDate] = useState(brodDate);
    const [allowCreateOrder, setAllowCreateOrder] = useState({
        isAllow: false,
        expiredTime: ''
    })
    
    // Use the custom basket hook
    const {
        isBasketOpen,
        basketProducts,
        basketQuantities,
        handleToggleBasket,
        handleCloseBasket
    } = useBasket({
        mode: 'create',
        packegeList,
        product,
        goodsListDefault
    });
    
    
    // const neededStatus = selectBrodMigdal(defaults, 549, 'Logical_Value');
    const neededStatus = useMemo(() => {
        if(!selectedCustomer) return false
        return !!selectedCustomer.NeedGrowthGroup
        
    }, [selectedCustomer])
    const data = format(startDate, "yyyyMMdd");
    const dispatch = useDispatch()
    const navigate = useNavigate();

    // CHECKER DATE AND TIME
    const [week, setWeek] = useState([])
    const [handleTime, setHandleTime] = useState('')
    const currentTime = format(new Date(), "HHmm00");
    const currentDate = format(new Date(), "yyyyMMdd"); // HHmm00
    const chosedDay = format(startDate, "EEEE")

    const passDay = (Object.entries(week).filter(e => { return e.includes(chosedDay) })[0])
        ? (Object.entries(week).filter(e => { return e.includes(chosedDay) })[0])[1]
        : []
        
    let dateToggle = jumping ? data : data

    const {
        data: dataCustomersOrdered, 
        isLoading: isLoadingCustomersOrdered
    } = useDataFetcher(
        Orders.getExistOrdersForClients, getRights.includes("SELLER") ? dateToggle : ''
    )

    // !check date validation from week array. set day + 1 if current date is close. repeat if next day close as well
    const pushDate = (startDate) => {
        if (Object.values(week).some(item => item)) {
            const date = new Date(Number(startDate));
            if (passDay.length < 1 || passDay) {
                return setStartDate(date)
            }
            else if (!passDay && input !== '') {
                date.setDate(date.getDate() + 1);
                setStartDate(date);
            }
        }
    }

    useEffect(() => {
        pushDate(startDate);
    }, [data, customerId])

    // reload warning !
    useBeforeunload((event) => {
        if (product.length === 0 || generalRemark === '') {
            event.preventDefault();
        }
    });

    useEffect(() => {
        const filtered = product.filter(item => {
            return item.GroupID === +filterGoodsValue
        })
        setFilteredProduct(filtered)
    }, [filterGoodsValue])

    useEffect(() => {
        const filtered = product.filter(item => {
            return item.GroupID === +filterGoodsValue
        })
        setFilteredProduct(filtered)
    }, [product])

    const sumPrice = useMemo(() => {
        const targetArray = product.filter(product => product?.Packs > 0)
        return targetArray.reduce((acc, item) => {
            if (item.Price) {
                return acc + (item.Price * item.Packs)
            } else {
                return acc + 0
            }
        }, 0)
    }, [product])
    
    // add amlaca in each element of product list
    const setRecomenInArr = (arr, recArr) => {
        for (let i in arr) {
            for (let j in recArr) {
                if (arr[i].ProductID === recArr[j].ProductID && arr[i].VarietyID === recArr[j].VarietyID) {
                    arr[i].RecommendQty = recArr[j]
                }
            }
        }
        return arr
    }

    const getGoodPrice = async (prodID, varietyID, sizeID, packID, id, item) => {
        if((selectedCustomer && !selectedCustomer.PriceList) || isLoadPrice) return
        setIsLoadPrice(true)
        try {
            let res = await Orders.getGoodPrice(dateToggle, customerId, prodID, varietyID, sizeID, packID);
            let tempDef = [...goodsListDefault]
            let editedDef = tempDef.map((item) => {
                if(item.id === id) {
                    item.Price = res[0].CustPrice
                    item.MinPrice = res[0].MinimumPrice
                    item.isPriced = true
                    item.OriginalPrice = res[0].CustPrice
                }
                return item
            })
            setGoodsListDefault(editedDef)
            let temp = [...goodsList]
            let edited = temp.map((item) => {
                if(item.id === id) {
                    item.Price = res[0].CustPrice
                    item.MinPrice = res[0].MinimumPrice
                    item.isPriced = true
                    item.OriginalPrice = res[0].CustPrice
                }
                return item
            })
            setGoodsList([...edited])
        } catch (err) {} 
        finally {
            setIsLoadPrice(false)
        }
    }
    const getLastPrice = async (reqDat) => {
        const data = {
            ...reqDat,
            CustomerID: customerId
        }
        try {
            const res = await Price.getLstPrice(data)
            return res
        } catch (err) {
            handleNotifications("מחיר לא נמצא", {type: "error"})
        }
    }
    const getGoodsList = async (GET_GOODS_LIST, CustomerID, data) => {
        dispatch({ type: LOAD });
        // const currentDate = new Date();
        setShowSearchGoods(false)
        if(data) {
            setSelectedCustomer(data)
        }
        try {
            const res = await axios.get(GET_GOODS_LIST + CustomerID, {
                headers: {
                    'Authorization': 'Bearer ' + getToken
                },
                signal: controller.current.signal
            });
            
            setShowSearchGoods(true);
            let newArr = addIDForTheList(setRecomenInArr(res.data.recommendations, res.data.recomWithQtyBySales));
            if (neededStatus || !!selectedCustomer?.NeedGrowthGroup || !!data?.NeedGrowthGroup) {
                setGoodsList([])
                setGoodsListDefault(newArr)
                setProduct([])
                setSelectStatus(false);
            } else {
                setGoodsList(newArr)
                setGoodsListDefault(newArr)
                setProduct([])
                setSelectStatus(false)
            }
            setAddictionalDay(res.data.addNumberOfDaysToDeliveryDate);

        } catch (err) {
            if (!axios.isCancel(err)) {
                setModal({
                    open: true,
                    value: err.response?.data?.message,
                    mood: true
                })
                setTimeout(() => {
                    setModal({
                        ...modal,
                        open: false
                    })
                }, 3000)
                if (err.response?.data?.message === 'jwt malformed' || err.response?.data?.message === 'jwt expired') {
                    dispatch({ type: LOGOUT, payload: false });
                }
            }
        } finally {
            dispatch({ type: LOAD_END });
        }
    }

    const createLog = async (data) => {
        try {
             await axios({
                method: 'post',
                url: CREATE_ORDER_MONOG,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {
                    ...data
                }
            })
        } catch (err) {
            console.log(err.response)
        }
    }

    const calcTimeFunc = (time, format = "ms") => {
        const msPerHour = 3600000;
        const msPerMin = 60000;
        let hoursToMS = +time.substring(0, 2) * msPerHour;
        let minsToMS = +time.substring(3, 5) * msPerMin
        return format === 'ms' ? hoursToMS + minsToMS : hoursToMS + minsToMS
    }

    const checkTimeForSave = () => {
        const expiredTime = `${handleTime === '000000' ?
            getTimeBrod?.substring(0, 2) + ':' + getTimeBrod?.substring(2, 4) :
            handleTime?.substring(0, 2) + ':' + handleTime?.substring(2, 4)}`

        const timeExp = calcTimeFunc(expiredTime) / 60000;
        const timeCur = calcTimeFunc(currentTime) / 60000;
        
        const isAllowToSave = getRights.includes("OFFICE") 
                            || (handleTime === "000000"
                            ? currentTime < getTimeBrod || (+addictinalDay === 0 ? data - currentDate >= 1 : data - currentDate >= 2)
                            : currentTime < handleTime || (+addictinalDay === 0 ? data - currentDate >= 1 : data - currentDate >= 2))
        if (isAllowToSave) {
            setAllowCreateOrder({
                isAllow: true,
                expiredTime: expiredTime,
                timeLeft: timeExp - timeCur
            })
        }
        else {
            setAllowCreateOrder({
                isAllow: false,
                expiredTime: expiredTime,
                timeLeft: timeExp - timeCur
            })
        }
    }
    const postToWS = async (data) => {
        try {
            await Orders.passNewOrderToWS(data)
        } catch (err) {
            handleNotifications(err?.response?.data?.error || err?.response?.data?.message, {type: "error"})
        }
    }

    const validatePackageQuantities = () => {
        const productsWithPacks = product.filter(item => item.Packs > 0);
        
        for (const item of productsWithPacks) {
            const packType = checkPackType(packegeList, item.PackID);
            
            // If package type is NOT weight (not '1') and Packs has decimal value
            if (packType !== '1' && !Number.isInteger(item.Packs)) {
                return {
                    isValid: false,
                    message: `כמות חבילות חייבת להיות מספר שלם עבור ${item.ProductDesc || item.desc || 'מוצר'}`
                };
            }
        }
        
        return { isValid: true };
    };

    const createAzmana = async () => {
        let toggle = false
        setBlockSave(true);
        dispatch({ type: LOAD });

        // Validate package quantities before proceeding
        const validation = validatePackageQuantities();
        if (!validation.isValid) {
            setBlockSave(false);
            dispatch({ type: LOAD_END });
            vibrationFunc('warning');
            setModal({
                open: true,
                value: validation.message,
                mood: false
            });
            setTimeout(() => {
                setModal({
                    ...modal,
                    open: false
                });
            }, 3000);
            return;
        }

        const filtered = product.filter(item => {
            return item.GroupID === +filterGoodsValue
        }).map(e => {
            let {id, GroupID, ProdName, desc, ImageUrl, PriceGood, packType, isExistingOrder, isModified, ...rest} = e
            return rest
        })

        setFilteredProduct(filtered)
        // delete empty products
        let withOutEmptyProd = product.filter(item => item.Packs > 0).map(e => {
            let {id, GroupID, ProdName, desc, ImageUrl, PriceGood, packType, isExistingOrder, isModified, ...rest} = e
            return rest
        })

        if (product.some(e => { return e.Packs > 0 })) {
            if (
                allowCreateOrder.isAllow ||
               ( handleTime === "000000"
                ? currentTime < getTimeBrod || (+addictinalDay === 0 ? data - currentDate >= 1 : data - currentDate >= 2)
                : currentTime < handleTime || (+addictinalDay === 0 ? data - currentDate >= 1 : data - currentDate >= 2))
            ) {
                if (passDay) {
                                    const data = {
                    "CustomerID": customerId,
                    "Remark": generalRemark,
                    "Jumping": setAkpaca,
                    "Delivery_Date": dateToggle,
                    "ProductGroup": neededStatus ? +filterGoodsValue : 0,
                    'Products': neededStatus ? filtered : withOutEmptyProd
                }
                    try {
                        // let res = await Orders.createOrder(data)
                        let res = await Orders.createOrderGo(data)
                        setStatisFilter(true)
                        setModal({
                            open: true,
                            value: `ההזמנה ${res.OrderID} נוצרה בהצלחה`,
                            mood: true
                        })
                        setTimeout(() => {
                            setModal({
                                ...modal,
                                open: false
                            })
                        }, 3000)
                        const currDate = new Date().toISOString();
                        let curData = {
                            orderID: res?.OrderID,
                            user: getUser,
                            statusCode: 200,
                            payload: data,
                            requestType: "create",
                            date: {
                                date: currDate,
                                localDate: currentDate
                            },
                            history: [{
                                date: currDate,
                                StatusCode: 0,
                                StatusDesc: statusConverter(0).status
                            }],
                            update: []
                        }
                        navigate(LINKS.orders.clientOrders.mainUrl);
                        getAzmanot()
                        createLog(curData);
                        postToWS(res)
                        toggle = true
                        vibrationFunc();
                        setBlockSave(false);
                    } catch (err) {
                        setBlockSave(false);
                        dispatch({ type: LOAD_END });
                        console.log(err)
                        if (err?.response?.data) {
                            handleNotifications(err?.response?.data?.error || err?.response?.data?.message, {type: "error"})
                        }
                        vibrationFunc('warning');
                        let curData = {
                            orderID: 'error',
                            user: getUser,
                            statusCode: err?.response?.status || 0,
                            payload: err?.response?.data || '',
                            requestType: "create",
                            date: {
                                date: new Date(),
                            }
                        }
                        if (!toggle) {
                            createLog(curData);
                        }
                        
                    } finally {
                        dispatch({ type: LOAD_END });
                    }
                } else {
                    setBlockSave(false);
                    dispatch({ type: LOAD_END });
                    vibrationFunc('warning');
                    setModal({
                        open: true,
                        value: `לא ניתן להזמין ליום ${chosedDay === "Sunday" ? "ראשון"
                            : chosedDay === "Monday" ? "שני"
                                : chosedDay === "Tuesday" ? "שלישי"
                                    : chosedDay === "Wednesday" ? "רביעי"
                                        : chosedDay === "Thursday" ? "חמישי"
                                            : chosedDay === "Friday" ? "שישי"
                                                : "שבת"}`,
                        mood: false
                    })
                    setTimeout(() => {
                        setModal({
                            ...modal,
                            open: false
                        })
                    }, 3000)
                }
            } else {
                setBlockSave(false);
                dispatch({ type: LOAD_END });
                vibrationFunc('warning');
                setModal({
                    open: true,
                    value: `ניתן לבצע הזמנה עד - ${handleTime === '000000' ?
                        getTimeBrod.substring(0, 2) + ':' + getTimeBrod.substring(3, 4) :
                        handleTime.substring(0, 2) + ':' + handleTime.substring(3, 5)}`,
                    mood: false
                })
                setTimeout(() => {
                    setModal({
                        ...modal,
                        open: false
                    })
                }, 3000)
            }
        } else {
            dispatch({ type: LOAD_END });
            setBlockSave(false);
            vibrationFunc('warning');
            setModal({
                open: true,
                value: 'הזמנה ריקה',
                mood: false
            })
            setTimeout(() => {
                setModal({
                    ...modal,
                    open: false
                })
            }, 3000)
        }
        dispatch({type: LOAD_END})
    }

    useEffect(() => {
        if (clientListDefault && clientListDefault.length <= 1) {
            const item = clientListDefault[0]
            setSelectedCustomer(item)
            setCustomerId(item.CustomerID);
            setInput(item.Customer_Name.trim());
            getGoodsList(GET_GOODS_LIST, item.CustomerID, item);
            setHandleTime(item.To_PickupTime);
            setShowSearchGoods(true);
            setWeek({
                "Monday": item.Monday,
                "Tuesday": item.Tuesday,
                "Wednesday": item.Wednesday,
                "Thursday": item.Thursday,
                "Friday": item.Friday,
                "Saturday": item.Saturday,
                "Sunday": item.Sunday
            });
        }
        
    }, [])

    const collectDataProduct = (product, setProduct, RecID, id, VarietyID, packs, packType, ProductID, SizeID, remark, mlai, priceGood, GroupID, Price, SalePrice, desc, ImageUrl) => {
        // check ununiq id in array
        let tempArr = [...product]
        let found = tempArr.find((item) => {
            return item.id === id;
        })

        // if found, replace current element 
        if (found) {
            let indProd = tempArr.indexOf(found)
            tempArr.splice((indProd), 1)
        }

        const newProduct = {
            "id": id,
            "RecID": RecID,
            "VarietyID": VarietyID,
            "Packs": packs,
            "PackID": +packType,
            "ProductID": ProductID,
            "SizeID": SizeID,
            "Remark": remark,
            "Mlai": +mlai,
            "GroupID": GroupID,
            "Price": +priceGood,
            "SalePrice": SalePrice,
            "desc": desc,
            "ImageUrl": ImageUrl,
            "Update_Manual": Price === priceGood || (!Price && SalePrice === priceGood) ? false : true,

        };

        setProduct([...tempArr, newProduct]);
    }

    const filterGoods = async (imputGoods) => {
        if (filterGoodsValue !== null || filterGoodsValue === '100' || !neededStatus) {
            
            if (!neededStatus) {
                if (statusFilter) {
                    const filtered = goodsListDefault.filter(goods => {
                        return `${goods.ProductDesc.trim()} ${goods.VarietyDesc.trim()} ${goods.SizeID.trim()}`
                            .toLowerCase().includes(imputGoods.toLowerCase())
                    })
                    setInputGoods(imputGoods);
                    setGoodsList(filtered);
                }
                if (!statusFilter) {
                    const filtered = filteredExist.filter(goods => {
                        return `${goods.ProductDesc.trim()} ${goods.VarietyDesc.trim()} ${goods.SizeID.trim()}`
                            .toLowerCase().includes(imputGoods.toLowerCase())
                    })
                    setInputGoods(imputGoods);
                    setGoodsList(filtered);
                }
            } else {
                if (statusFilter) {
                    const filtered = goodsListDefault.filter(goods => {
                        return `${goods.ProductDesc.trim()} ${goods.VarietyDesc.trim()} ${goods.SizeID.trim()}`
                            .toLowerCase().includes(imputGoods.toLowerCase())
                            && goods.GroupArray.includes(+filterGoodsValue)
                    })
                    setInputGoods(imputGoods);
                    setGoodsList(filtered);
                }
                else {
                    const filtered = filteredExist.filter(goods => {
                        return `${goods.ProductDesc.trim()} ${goods.VarietyDesc.trim()} ${goods.SizeID.trim()}`
                            .toLowerCase().includes(imputGoods.toLowerCase())
                            && goods.GroupArray.includes(+filterGoodsValue)
                    })
                    setInputGoods(imputGoods);
                    setGoodsList(filtered);
                }
            }
        }
        else {
            setModal({
                open: true,
                value: 'בחר קבוצה',
                mood: false
            })
            setTimeout(() => {
                setModal({
                    ...modal,
                    open: false
                })
            }, 3000)
        }
    }
    
    // check here for bug deleting prod
    const filterExist = () => {
        let newArr = []
        for (let i = 0; i < goodsList.length; i++) {
            for (let j = 0; j < product.length; j++) {
                if (product[j].id === goodsList[i].id && product[j].Packs > 0) {
                    newArr.push(goodsList[i])
                }
            }
        }
        if (newArr.length > 0 && statusFilter) {
            setGoodsList(newArr)
            setStatisFilter(false)
            setFilteredExist(newArr)
        }
    }

    const filterClose = async () => {
        if (!statusFilter && !filterToggleStatus) {
            setGoodsList(goodsListDefault)
            setStatisFilter(true)
        }
        if (!statusFilter && filterToggleStatus) {
            setGoodsList(fileterGoodsDefault)
            setStatisFilter(true)
        }
    }

    // set new Arr, if product have packs - add key/value with packs type
    const filterExistDef = async () => {
        let newArr = [...goodsListDefault]
        for (let i = 0; i < goodsListDefault.length; i++) {
            for (let j = 0; j < product.length; j++) {
                if (product[j].id === goodsListDefault[i].id && product[j].Packs >= 0) {
                    newArr[i].Packs = product[j].Packs !==0 ? product[j].Packs: newArr[i].Packs
                    newArr[i].Price = product[j].Price !== 0 ? product[j].Price: newArr[i].Price
                    newArr[i].Mlai = product[j].Mlai !== 0 ? product[j].Mlai:  newArr[i].Mlai
                    newArr[i].PackID = product[j].PackID !== 0 ? product[j].PackID:  newArr[i].PackID
                }
            }
        }
        setGoodsListDefault(newArr)
    }

    //collect data from inputs and create new azmanot array
    const [dataLength, setDataLength] = useState(20)
    const loadAddData = () => {
        let newArr = [...goodsListDefault]
        if (goodsListDefault[dataLength]) {
            let currList = newArr.splice(0, dataLength);
            setGoodsList(currList)
        } else {
            setGoodsList(newArr)
        }
        setDataLength(prev => prev += 20)
    }
    // Remark handlers are now provided by the remarkModal hook
    // switch value of checkbox for selecting akpaca type
    const chengeAkpaca = () => {
        setJumping(!jumping)
    }
    useEffect(() => {
        setOrderTotal(0);
        checkTimeForSave();
    }, [customerId])
const handleControllBasket = () => {
    handleToggleBasket();
}
    useEffect(() => {
        filterExistDef();
    }, [product])

    let setAkpaca = jumping ? 2 : 1;
    let floatSideMenu = getPresetBrod ? <FloatContainer
        setPresetWindow={setPresetWindow}
        customerId={customerId}
        filterGoodsValue={filterGoodsValue}
        handleOpenRemarkModal={handleOpenRemarkModal}
        getPresetBrod={getPresetBrod}
        neededStatus={neededStatus}
        handleControllBasket={handleControllBasket}
    /> : ''
    let presetWindowToggle = presetWindow && getPresetBrod ? <PresetModal
        setPresetWindow={setPresetWindow}
        modal={modal}
        setModal={setModal}
        customerId={customerId}
        filterGoodName={filterGoodName}
        setGoodsList={setGoodsList}
        setGoodsListDefault={setGoodsListDefault}
        presetWindow={presetWindow}
        setProduct={setProduct}
        setProductDefault={setProductDefault}
        setShowGoodsList={setShowGoodsList}
        setFilterGoodsDefault={setFilterGoodsDefault}
        product={product}
        neededStatus={neededStatus}
        goodsListDefault={goodsListDefault}
        goodsListTemp={goodsListTemp}
        filterGoodsValue={filterGoodsValue}
        getPresetBrod={getPresetBrod}
    /> : '';
    // console.log(handleTime)
    const applyClient = (found) => {
        if (!found) return;
        setSelectedCustomer(found);
        setInput(found.Customer_Name.trim());
        setCustomerId(found.CustomerID);
        getGoodsList(GET_GOODS_LIST, found.CustomerID, found);
        setHandleTime(found.To_PickupTime);
        setProduct([]);
        handleSaveRemark('');
        setWeek({
            "Monday": found.Monday,
            "Tuesday": found.Tuesday,
            "Wednesday": found.Wednesday,
            "Thursday": found.Thursday,
            "Friday": found.Friday,
            "Saturday": found.Saturday,
            "Sunday": found.Sunday,
        });
    };

    const handleSelectFromRecommendClient = (item) => {
        const found = clientListDefault.find(e => e.CustomerID === item.CustomerID);
        applyClient(found);
    };

    const handleSelectClient = (client) => {
        applyClient(client);
    };
    let checkButtoFilter = statusFilter ?
        <KbdChipButton aria-label='filter ordered' count={orderTotal} onClick={() => { filterExist() }}>
            <ChecklistIcon />
        </KbdChipButton>
        :
        <KbdChipButton aria-label='close filter' count={orderTotal} onClick={() => { filterClose() }}>
            <CloseIcon />
        </KbdChipButton>
    const isAllowToShowPrice = getMhir || selectedCustomer?.DeliveryPrice !== 0

    let showBtnFilter = showSearchGoods ? checkButtoFilter : '';
    let filterBarGoods = showSearchGoods ?
        <ProductGroupSelector
            fileterGoods={fileterGoods}
            setFilterGoodsValue={setFilterGoodsValue}
            goodsListDefault={goodsListDefault}
            setGoodsList={setGoodsList}
            setFilterToggleStatus={setFilterToggleStatus}
            setFilterGoodsDefault={setFilterGoodsDefault}
            setFilteredExist={setFilteredExist}
            setFilterGoodName={setFilterGoodName}
            selectStatus={selectStatus}
            neededStatus={neededStatus}
        /> :
        ''
    let azmanaAccept = product.length > 0 ? false : true

    const showTimeWarning = allowCreateOrder.isAllow && allowCreateOrder.timeLeft < 30;

    const showAkpaca = showSearchGoods && selectedCustomer?.Allow_Bouncing === 1;

    const headerBlock = (
        <OrderHeaderBlock
            client={
                <ClientSelector
                    clients={clientListDefault || []}
                    value={selectedCustomer ?? null}
                    onSelect={handleSelectClient}
                    disabled={orderTotal !== 0 || (clientListDefault?.length || 0) <= 1}
                    placeholder={'בחר לקוח'}
                />
            }
            date={
                <DateField
                    disabled={!dateBlocker && !jumping}
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                />
            }
        />
    );

    const stickyNotice = showTimeWarning ? (
        <Disclaimer text={`ניתן לבצע הזמנה עד ${allowCreateOrder?.expiredTime}`} />
    ) : null;

    const goodsToolbar = (
        <OrdersToolbar
            groupSelector={filterBarGoods || null}
            actions={
                <>
                    <KbdChipButton aria-label='remark' onClick={() => handleOpenRemarkModal()}>
                        <EditIcon />
                    </KbdChipButton>
                    <KbdChipButton aria-label='basket' onClick={() => handleControllBasket()}>
                        <BasketIcon />
                    </KbdChipButton>
                    {showAkpaca && (
                        <KbdChipButton
                            aria-label='הקפצה'
                            title='הקפצה'
                            variant={jumping ? 'accent' : 'default'}
                            onClick={() => chengeAkpaca()}
                        >
                            <SpeedIcon />
                        </KbdChipButton>
                    )}
                </>
            }
            filterButton={showBtnFilter || null}
            searchValue={imputGoods}
            onSearchChange={(v) => filterGoods(v)}
        />
    );

    return (
        <>
            {presetWindowToggle}
            {floatSideMenu}
            {
                isRemarkModalOpen &&
                <ColumModal
                    open={isRemarkModalOpen}
                    controlFunc={handleOpenRemarkModal}
                    title={'הערות'}
                    Children={RemarkOrderModal}
                    childrenProps={modalRemarkProps}
                />
            }
            <Basket
                Remark={generalRemark}
                products={basketProducts}
                quantities={basketQuantities}
                isOpen={isBasketOpen}
                onClose={handleCloseBasket}
                onToggle={handleToggleBasket}
            />
            <OrdersPageLayout title={'הזמנה חדשה'}>
                {showSearchGoods && showGoodsList ? (
                    <GoodsList
                        presetWindow={presetWindow}
                        goodsListDefault={goodsListDefault}
                        setProductDefault={setProductDefault}
                        getMlai={getMlai}
                        getMhir={isAllowToShowPrice}
                        goodsList={goodsList}
                        setProduct={setProduct}
                        product={product}
                        chengeAkpaca={chengeAkpaca}
                        packegeList={packegeList}
                        filterClose={filterClose}
                        setOrderTotal={setOrderTotal}
                        orderTotal={orderTotal}
                        collectDataProduct={collectDataProduct}
                        filterGoodsValue={filterGoodsValue}
                        dateForAmlaca={{ toDay: currentDate, choosen: data }}
                        isEditArizot={isEditArizot}
                        loadAddData={loadAddData}
                        isEditPrice={isEditPrice}
                        allowCreateOrder={allowCreateOrder}
                        getGoodPrice={getGoodPrice}
                        isLoadPrice={isLoadPrice}
                        getLastPrice={getLastPrice}
                        scrollHeader={headerBlock}
                        stickyHeader={goodsToolbar}
                        belowSticky={stickyNotice}
                    />
                ) : (
                    <PreSelectColumn>
                        {headerBlock}
                        {dataCustomersOrdered && (
                            <CustomersOrdered
                                handleClick={handleSelectFromRecommendClient}
                                data={dataCustomersOrdered}
                            />
                        )}
                    </PreSelectColumn>
                )}
            </OrdersPageLayout>
            <OrderActionDock
                onClose={() => navigate(LINKS.orders.clientOrders.mainUrl)}
                onSave={createAzmana}
                saveLabel={'שמור'}
                saveHidden={!allowCreateOrder?.isAllow}
                saveDisabled={blockSave || azmanaAccept}
            />
        </>
    );
}

const PreSelectColumn = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 12px;
    direction: rtl;
    &::-webkit-scrollbar { width: 0; }
`
